import { Pipe, PipeTransform } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Pipe({
  name: 'errors',
  standalone: true,
})
export class ErrorsPipe implements PipeTransform {
  transform(
    error: Error,
    info: 'status' | 'message' | 'url'
  ): string | number | undefined {
    console.log({ error });
    if (error instanceof HttpErrorResponse) {
      if (info === 'status') {
        return error.status;
      } else if (info === 'message') {
        return error.message;
      } else if (info === 'url') {
        return error.url || undefined;
      }
    }
    return undefined;
  }
}

@Pipe({
  name: 'isJsonApiError',
  standalone: true,
})
export class IsJsonApiError implements PipeTransform {
  transform(error: Error): boolean {
    if (error instanceof HttpErrorResponse) {
      return !!error.error.jsonapi;
    }
    return false;
  }
}

@Pipe({
  name: 'jsonApiErrorMessage',
  standalone: true,
})
export class JsonApiErrorMessage implements PipeTransform {
  transform(error: Error): string | undefined {
    if (error instanceof HttpErrorResponse) {
      const errors = error.error.errors;
      if (errors && errors.length > 0) {
        return errors[0].detail;
      }
    }
    return undefined;
  }
}
